import React from 'react'

const QrCode = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 21.5V17.5H5.5V21H9V22.5H5C4.44772 22.5 4 22.0523 4 21.5ZM5.5 7H9V5.5H5C4.44772 5.5 4 5.94772 4 6.5V10.5H5.5V7ZM22.5 7V10.5H24V6.5C24 5.94772 23.5523 5.5 23 5.5H19V7H22.5ZM22.5 21H19V22.5H23C23.5523 22.5 24 22.0523 24 21.5V17.5H22.5V21ZM7 10.5C7 9.67157 7.67157 9 8.5 9H19.5C20.3284 9 21 9.67157 21 10.5V17.5C21 18.3284 20.3284 19 19.5 19H8.5C7.67157 19 7 18.3284 7 17.5V10.5ZM8.5 11C8.22386 11 8 11.2239 8 11.5C8 11.7761 8.22386 12 8.5 12H19.5C19.7761 12 20 11.7761 20 11.5C20 11.2239 19.7761 11 19.5 11H8.5ZM13.9342 16.7481C14.4118 15.9123 14.8675 15.4151 15.2418 15.1505C15.619 14.8839 15.8659 14.8818 15.9814 14.9164C16.0841 14.9472 16.1971 15.041 16.2454 15.2681C16.2949 15.5009 16.2642 15.8538 16.0529 16.2764C15.9294 16.5234 16.0295 16.8237 16.2765 16.9472C16.5235 17.0707 16.8238 16.9706 16.9473 16.7236C17.1728 16.2725 17.4108 15.995 17.6102 15.8412C17.8133 15.6845 17.9464 15.676 17.9919 15.6825C18.0165 15.686 18.0451 15.6933 18.0716 15.7633C18.1046 15.8501 18.1269 16.0385 18.0257 16.3419C17.9384 16.6039 18.08 16.887 18.342 16.9743C18.6039 17.0617 18.8871 16.9201 18.9744 16.6581C19.1233 16.2115 19.1456 15.7749 19.0066 15.4086C18.8613 15.0254 18.5462 14.7515 18.1333 14.6925C17.811 14.6465 17.4845 14.7381 17.1875 14.9196C17.0531 14.4734 16.7422 14.1006 16.2688 13.9586C15.7592 13.8057 15.1937 13.9599 14.6646 14.3339C14.1327 14.7099 13.5884 15.3377 13.066 16.2519C12.929 16.4917 13.0123 16.7971 13.252 16.9341C13.4918 17.0711 13.7972 16.9878 13.9342 16.7481Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default QrCode
